import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Stack,
  Fade,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';

const SessionCompletePage = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        height: '100dvh',
        width: '100vw',
        background: 'linear-gradient(180deg, #001665 0%, #000b33 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      <Fade in timeout={800}>
        <Paper
          sx={{
            p: isSmallMobile ? 3 : 5,
            borderRadius: 8,
            textAlign: 'center',
            maxWidth: 400,
            width: '100%',
            boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
            position: 'relative',
            overflow: 'hidden',
            maxHeight: '90dvh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {/* Top success accent */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 6,
              bgcolor: '#00e676',
            }}
          />

          <Stack spacing={isSmallMobile ? 2 : 3} alignItems="center">
            {/* Success icon */}
            <Box
              sx={{
                width: isSmallMobile ? 70 : 90,
                height: isSmallMobile ? 70 : 90,
                bgcolor: '#e8f5e9',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
              }}
            >
              <CheckCircleIcon
                sx={{
                  fontSize: isSmallMobile ? 42 : 54,
                  color: '#2e7d32',
                }}
              />
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                color: '#001665',
                fontSize: isSmallMobile ? '1.4rem' : '1.8rem',
                lineHeight: 1.2,
              }}
            >
              Entry Complete
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#2e7d32',
                fontWeight: 700,
                bgcolor: '#e8f5e9',
                px: 3,
                py: 0.6,
                borderRadius: '20px',
                fontSize: isSmallMobile ? '0.8rem' : '0.9rem',
              }}
            >
              SESSION SUCCESSFULLY VERIFIED
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: '#555',
                lineHeight: 1.4,
                fontSize: isSmallMobile ? '0.85rem' : '1rem',
              }}
            >
              Your access request has been processed and this session is now
              closed for security reasons.
            </Typography>

            {/* Security notice */}
            <Box
              sx={{
                width: '100%',
                p: 2,
                bgcolor: '#f0f4ff',
                borderRadius: 4,
                border: '1px dashed #001665',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <LockIcon sx={{ color: '#001665', fontSize: 22 }} />
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'left',
                  fontWeight: 600,
                  color: '#001665',
                  fontSize: isSmallMobile ? '0.75rem' : '0.85rem',
                }}
              >
                This link is no longer active and cannot be reused. You may
                safely close this page.
              </Typography>
            </Box>

            <Typography
              variant="caption"
              sx={{
                color: 'text.disabled',
                fontWeight: 600,
                fontSize: isSmallMobile ? '0.65rem' : '0.75rem',
              }}
            >
              NUVE SECURE ACCESS SYSTEM
            </Typography>
          </Stack>
        </Paper>
      </Fade>
    </Box>
  );
};

export default SessionCompletePage;
